var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTime = function SvgTime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    fill: "none",
    stroke: "#3953fb",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.827,9.08v8l-4.484,3.505",
    transform: "translate(-6.829 -5.771)",
    fill: "none",
    stroke: "#959cf2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time.65ee6c0b.svg";
export { ForwardRef as ReactComponent };